import { createResource } from '@gandi/resource/redux';
export const defaultTemplateResource = createResource('default-template');